import { Star } from "lucide-react";
import { useT } from "../lib/i18n";
import { hapticSelect } from "../lib/haptics";

interface Props {
  title: string;
  subtitle?: string;
  value?: string;
  onAdd: () => void;
  /** When provided, renders a star toggle before the add button. */
  starred?: boolean;
  onToggleStar?: (next: boolean) => void;
  /** Reference-data entry (F9) rather than a crowdsourced community one. */
  verified?: boolean;
}

/** One row in the Frequent / Search lists: name (+ optional subtitle),
 *  a trailing value (kcal), and a round "+" quick-add button. */
export function FoodResultRow({ title, subtitle, value, onAdd, starred, onToggleStar, verified }: Props) {
  const t = useT();
  return (
    <div className="flex items-center gap-3 py-2.5">
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">
          {title}
          {verified && (
            <span className="ml-1.5 align-middle text-sm text-success" title={t("food.verified_hint")}>
              ✓ {t("food.verified")}
            </span>
          )}
        </div>
        {subtitle && <div className="text-sm text-fg-muted truncate">{subtitle}</div>}
      </div>
      {value && <span className="text-sm text-fg-muted tabular-nums whitespace-nowrap">{value}</span>}
      {onToggleStar && (
        <button
          onClick={() => { hapticSelect(); onToggleStar(!starred); }}
          aria-label={starred ? t("fav.unstar", { name: title }) : t("fav.star", { name: title })}
          aria-pressed={!!starred}
          className="p-2.5 -m-1 press"
        >
          <Star
            size={20}
            className={starred ? "text-warn" : "text-fg-faint"}
            fill={starred ? "currentColor" : "none"}
          />
        </button>
      )}
      <button
        onClick={onAdd}
        aria-label={t("add.add_item", { name: title })}
        className="w-11 h-11 rounded-full bg-brand text-on-brand text-xl leading-none flex items-center justify-center flex-shrink-0 press"
      >
        +
      </button>
    </div>
  );
}
